/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Timeline_history = ReadonlyArray<{
    readonly uuid: string;
    readonly isArchived: boolean;
    readonly responseSendLogs: ReadonlyArray<{
        readonly sentAt: string;
        readonly emailAddress: string;
    }>;
    readonly employer: {
        readonly uuid: string;
        readonly responseLink: string | null;
        readonly application: {
            readonly uuid: string;
            readonly name: string;
            readonly contactEmail: string;
            readonly jobTitle: string;
            readonly reasonForLeaving: string;
            readonly dates: ReadonlyArray<{
                readonly startDate: string;
                readonly endDate: string;
            }>;
            readonly address: {
                readonly addressLine1: string;
                readonly addressLine2: string;
                readonly county: string;
                readonly postCode: string;
                readonly country: string;
            };
            readonly absent: boolean;
        } | null;
        readonly response: {
            readonly uuid: string;
            readonly datesEmployed: ReadonlyArray<{
                readonly startDate: string;
                readonly endDate: string;
            }>;
            readonly positionsHeld: string;
            readonly reasonForLeaving: string;
            readonly wouldEmploy: boolean;
            readonly wouldEmployReason: string;
            readonly absence: boolean;
            readonly datesAbsent: ReadonlyArray<{
                readonly startDate: string;
                readonly endDate: string;
            } | null>;
            readonly otherInformation: string;
            readonly orgName: string;
            readonly orgContactName: string;
            readonly orgJobTitle: string;
            readonly orgTelephone: string;
            readonly orgAddress: {
                readonly addressLine1: string;
                readonly addressLine2: string;
                readonly county: string;
                readonly postCode: string;
                readonly country: string;
            };
        } | null;
    } | null;
    readonly education: {
        readonly uuid: string;
        readonly responseLink: string | null;
        readonly application: {
            readonly uuid: string;
            readonly name: string;
            readonly contactEmail: string;
            readonly dates: ReadonlyArray<{
                readonly startDate: string;
                readonly endDate: string;
            }>;
            readonly examsTaken: string;
            readonly address: {
                readonly addressLine1: string;
                readonly addressLine2: string;
                readonly county: string;
                readonly postCode: string;
                readonly country: string;
            };
        } | null;
        readonly response: {
            readonly uuid: string;
            readonly dates: ReadonlyArray<{
                readonly startDate: string;
                readonly endDate: string;
            }>;
            readonly courseDetails: string;
            readonly examResults: string;
            readonly otherInformation: string;
            readonly orgName: string;
            readonly orgContactName: string;
            readonly orgJobTitle: string;
            readonly orgTelephone: string;
            readonly orgAddress: {
                readonly addressLine1: string;
                readonly addressLine2: string;
                readonly county: string;
                readonly postCode: string;
                readonly country: string;
            };
        } | null;
    } | null;
    readonly unemployed: {
        readonly uuid: string;
        readonly responseLink: string | null;
        readonly application: {
            readonly uuid: string;
            readonly dates: ReadonlyArray<{
                readonly startDate: string;
                readonly endDate: string;
            }>;
            readonly reasonForUnemployment: string;
            readonly hadBenefits: boolean;
        } | null;
        readonly response: {
            readonly uuid: string;
            readonly datesAccurate: boolean;
            readonly alternateDates: ReadonlyArray<{
                readonly startDate: string;
                readonly endDate: string;
            }>;
            readonly lengthKnown: string;
            readonly relation: string;
            readonly inUK: boolean;
            readonly travelDetails: string;
            readonly employed: boolean;
            readonly employedDetails: string;
            readonly whereLived: string;
            readonly whatDoing: string;
            readonly financialSupport: string;
            readonly lacksIntegrity: boolean;
            readonly integrityDetail: string;
            readonly otherInformation: string;
            readonly occupation: string;
            readonly unavailableFrom: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly daytimeTelephone: string;
            readonly homeTelephone: string;
            readonly address: {
                readonly addressLine1: string;
                readonly addressLine2: string;
                readonly county: string;
                readonly postCode: string;
                readonly country: string;
            };
        } | null;
    } | null;
    readonly selfEmployed: {
        readonly uuid: string;
        readonly responseLink: string | null;
        readonly application: {
            readonly uuid: string;
            readonly accountantName: string;
            readonly contactEmail: string;
            readonly dates: ReadonlyArray<{
                readonly startDate: string;
                readonly endDate: string;
            }>;
            readonly address: {
                readonly addressLine1: string;
                readonly addressLine2: string;
                readonly county: string;
                readonly postCode: string;
                readonly country: string;
            };
        } | null;
        readonly response: {
            readonly uuid: string;
            readonly dates: ReadonlyArray<{
                readonly startDate: string;
                readonly endDate: string;
            }>;
            readonly selfEmploymentDetails: string;
            readonly businessName: string;
            readonly tradingName: string;
            readonly lacksIntegrity: boolean;
            readonly integrityDetail: string;
            readonly otherInformation: string;
            readonly orgName: string;
            readonly orgContactName: string;
            readonly orgJobTitle: string;
            readonly orgTelephone: string;
            readonly orgAddress: {
                readonly addressLine1: string;
                readonly addressLine2: string;
                readonly county: string;
                readonly postCode: string;
                readonly country: string;
            };
        } | null;
    } | null;
    readonly " $refType": "Timeline_history";
}>;
export type Timeline_history$data = Timeline_history;
export type Timeline_history$key = ReadonlyArray<{
    readonly " $data"?: Timeline_history$data;
    readonly " $fragmentRefs": FragmentRefs<"Timeline_history">;
}>;



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "responseLink",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contactEmail",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "reasonForLeaving",
        "args": null,
        "storageKey": null
    } as any), v5 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "startDate",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "endDate",
            "args": null,
            "storageKey": null
        } as any)
    ], v6 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "dates",
        "storageKey": null,
        "args": null,
        "concreteType": "HistoryDates",
        "plural": true,
        "selections": (v5 /*: any*/)
    } as any), v7 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine1",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine2",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "county",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "postCode",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "country",
            "args": null,
            "storageKey": null
        } as any)
    ], v8 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "address",
        "storageKey": null,
        "args": null,
        "concreteType": "Address",
        "plural": false,
        "selections": (v7 /*: any*/)
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "otherInformation",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgName",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgContactName",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgJobTitle",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgTelephone",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "orgAddress",
        "storageKey": null,
        "args": null,
        "concreteType": "Address",
        "plural": false,
        "selections": (v7 /*: any*/)
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lacksIntegrity",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "integrityDetail",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "Timeline_history",
        "type": "BackgroundHistory",
        "metadata": {
            "plural": true
        },
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isArchived",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "responseSendLogs",
                "storageKey": null,
                "args": null,
                "concreteType": "ResponseSendLog",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sentAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "emailAddress",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "employer",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundHistoryEmployer",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "application",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundCheckEmployerApplication",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v2 /*: any*/),
                            (v3 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "jobTitle",
                                "args": null,
                                "storageKey": null
                            },
                            (v4 /*: any*/),
                            (v6 /*: any*/),
                            (v8 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "absent",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "response",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundCheckEmployerResponse",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "datesEmployed",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "HistoryDates",
                                "plural": true,
                                "selections": (v5 /*: any*/)
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "positionsHeld",
                                "args": null,
                                "storageKey": null
                            },
                            (v4 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "wouldEmploy",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "wouldEmployReason",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "absence",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "datesAbsent",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "HistoryDates",
                                "plural": true,
                                "selections": (v5 /*: any*/)
                            },
                            (v9 /*: any*/),
                            (v10 /*: any*/),
                            (v11 /*: any*/),
                            (v12 /*: any*/),
                            (v13 /*: any*/),
                            (v14 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "education",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundHistoryEducation",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "application",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundCheckEducationApplication",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v2 /*: any*/),
                            (v3 /*: any*/),
                            (v6 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "examsTaken",
                                "args": null,
                                "storageKey": null
                            },
                            (v8 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "response",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundCheckEducationResponse",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v6 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "courseDetails",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "examResults",
                                "args": null,
                                "storageKey": null
                            },
                            (v9 /*: any*/),
                            (v10 /*: any*/),
                            (v11 /*: any*/),
                            (v12 /*: any*/),
                            (v13 /*: any*/),
                            (v14 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "unemployed",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundHistoryUnemployed",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "application",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundCheckUnemployedApplication",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v6 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "reasonForUnemployment",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hadBenefits",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "response",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundCheckUnemployedResponse",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "datesAccurate",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "alternateDates",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "HistoryDates",
                                "plural": true,
                                "selections": (v5 /*: any*/)
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "lengthKnown",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "relation",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "inUK",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "travelDetails",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "employed",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "employedDetails",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "whereLived",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "whatDoing",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "financialSupport",
                                "args": null,
                                "storageKey": null
                            },
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v9 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "occupation",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "unavailableFrom",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "firstName",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "lastName",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "daytimeTelephone",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "homeTelephone",
                                "args": null,
                                "storageKey": null
                            },
                            (v8 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "selfEmployed",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundHistorySelfEmployed",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "application",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundCheckSelfEmployedApplication",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "accountantName",
                                "args": null,
                                "storageKey": null
                            },
                            (v3 /*: any*/),
                            (v6 /*: any*/),
                            (v8 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "response",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundCheckSelfEmploymentResponse",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v6 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "selfEmploymentDetails",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "businessName",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "tradingName",
                                "args": null,
                                "storageKey": null
                            },
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v9 /*: any*/),
                            (v10 /*: any*/),
                            (v11 /*: any*/),
                            (v12 /*: any*/),
                            (v13 /*: any*/),
                            (v14 /*: any*/)
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '2ab2907e3a0f93d8b0abfd5a3c424a07';
export default node;
